import { calculateLocatinVars } from '../../../libs/browser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonDescription from '../../../components/CommonDescription';
import CommonIconButton from '../../../components/CommonIconButton';
import CommonPageTitle from '../../../components/CommonPageTitle';
import Context from '../../../provider';
import ErrorPage from '../../../pages/ErrorPage';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LogoFooterComponent from '../../../components/LogoFooterComponent';
import React, { useContext, useEffect, useState } from 'react';
import config from '../../../config';
import memberApi from '../../../libs/api/memberApi';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function WebJoinInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const { init, lang, me, dispatch } = useContext(Context);

  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [pageNotFound, setPageNotFound] = useState(false);

  const fetchData = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const page = await memberApi.getPage({ ruri: locationVars.join('/') });
      setData(page);
      setLoaded(true);
    } catch (error) {
      setPageNotFound(true);
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (init) fetchData();
  }, [init]);

  // This page only allow logged in user
  useEffect(() => {
    if (init && me) {
      if (me.status === 'activated') {
        navigate(`${config.basename}`);
      }
    }
  }, [init, me]);

  const getSectionStyle = (section) => {
    const style = {};
    if (section?.color_background_class) style.backgroundColor = section.color_background_class;
    if (section?.color_foreground_class) style.color = section.color_foreground_class;
    if (section?.background_texture) style.backgroundImage = `url(${section.background_texture})`;
    return style;
  };

  return (
    (
      <>
        {pageNotFound && <ErrorPage type="notFound" />}
        {
          !pageNotFound &&
          <div className='web-join-info-page'>

            <div className="y-overflow gray-block info-container">
              <div className="section-max-container white-block page-content-container">
                {data?.title?.[lang] && <CommonPageTitle title={data?.title?.[lang]} />}
                {loaded && (data?.sections ??[]).map((section) => {
                  return (
                    <section className={ section.container_behavior ?? null } key={section.anchor} style={getSectionStyle(section)}>
                      <CommonDescription
                        title={section.hide_title ? null : section?.title?.[lang]}
                        data={section?.content?.[lang]}
                      />
                    </section>
                  );
                })}

                <div className="btn-container">
                  <CommonIconButton
                    text={t('common.tier-benefits')}
                    alignItems = "unset"
                    btnBackgroundColor= "#ffffff"
                    btnColor= "#004899"
                    border = "0.0625rem solid #004899"
                    btnWidth= { lang === 'en' ? "13rem" : '10rem'}
                    padding = "0.75rem 2rem"
                    btnFontSize = "1rem"
                    btnFontWeight = "700"
                    onClick={() => {
                      navigate(`${config.basename}`, {
                        state: {
                          toClass: '.benefits-section-cont-bg'
                        }
                      });
                    }}
                  />
                  <CommonIconButton
                    text={t('join-info.join-btn')}
                    endIcon= {<KeyboardArrowRightIcon />}
                    alignItems = "unset"
                    backgroundColor= "#004899"
                    btnColor= "#ffffff"
                    btnWidth= { lang === 'en' ? "13rem" : '10rem'}
                    padding = "0.75rem 2rem"
                    btnFontSize = "1rem"
                    btnFontWeight = "700"
                    onClick={() => {
                      navigate(`${config.basename}login`);
                    }}
                  />
                </div>
              </div>

              <div className="black-block full-width">
                <LogoFooterComponent />
              </div>
            </div>
          </div>
        }
      </>
    )
  );
}